export default __webpack_public_path__ + "static/media/elo.e9d4e692.svg";